import ComplaintsAdmin from '../../components/ComplaintsAdmin';

export default function Complaints() {
  return <ComplaintsAdmin />;
}
